// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: r_lPqUT3sUGr
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import BankTransferButton from "../../BankTransferButton"; // plasmic-import: rey7Nya4BVsS/component
import CardPaymentButton from "../../CardPaymentButton"; // plasmic-import: OfVv5HyvOBk9/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicEscrowPaymentsPagePreview.module.css"; // plasmic-import: r_lPqUT3sUGr/css
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: sgRe6pjmwXSr/icon
import Line2Icon from "./icons/PlasmicIcon__Line2"; // plasmic-import: pAewef34g4ck/icon
import Line1Icon from "./icons/PlasmicIcon__Line1"; // plasmic-import: MRg3okKdNvAo/icon
import Layer11Icon from "./icons/PlasmicIcon__Layer11"; // plasmic-import: z3YAObc8gkKH/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: jmxAADuTvJ3W/icon

createPlasmicElementProxy;

export const PlasmicEscrowPaymentsPagePreview__VariantProps = new Array();

export const PlasmicEscrowPaymentsPagePreview__ArgProps = new Array(
  "merchantName",
  "sendText",
  "contractName",
  "amount",
  "milestoneName",
  "escrowDeposit",
  "milestoneOrContract"
);

const $$ = {};

function PlasmicEscrowPaymentsPagePreview__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__wx6U)}>
            <Icon4Icon
              data-plasmic-name={"goBackArrow"}
              data-plasmic-override={overrides.goBackArrow}
              className={classNames(projectcss.all, sty.goBackArrow)}
              role={"img"}
            />

            <div
              data-plasmic-name={"goBackText"}
              data-plasmic-override={overrides.goBackText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.goBackText
              )}
            >
              {"Go Back"}
            </div>
            <div
              data-plasmic-name={"sendButton"}
              data-plasmic-override={overrides.sendButton}
              className={classNames(projectcss.all, sty.sendButton)}
            >
              <div
                data-plasmic-name={"sendText"}
                data-plasmic-override={overrides.sendText}
                className={classNames(projectcss.all, sty.sendText)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Send",
                  value: args.sendText,
                  className: classNames(sty.slotTargetSendText)
                })}
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"previewBody"}
            data-plasmic-override={overrides.previewBody}
            className={classNames(projectcss.all, sty.previewBody)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__b3PHq)}>
              <div
                data-plasmic-name={"companyName"}
                data-plasmic-override={overrides.companyName}
                className={classNames(projectcss.all, sty.companyName)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Vayner Media",
                  value: args.merchantName,
                  className: classNames(sty.slotTargetMerchantName)
                })}
              </div>
              <div
                data-plasmic-name={"rectangle29"}
                data-plasmic-override={overrides.rectangle29}
                className={classNames(projectcss.all, sty.rectangle29)}
              >
                <div
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  className={classNames(projectcss.all, sty.figmaPaste)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__tbUyP)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__lVb1G
                          )}
                        >
                          {"Requested Milestone Deposit: $900.00"}
                        </div>
                      ),

                      value: args.escrowDeposit,
                      className: classNames(sty.slotTargetEscrowDeposit)
                    })}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__iyAb)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: "Milestone 1: Initial Setup",
                      value: args.milestoneOrContract,
                      className: classNames(sty.slotTargetMilestoneOrContract)
                    })}
                  </div>
                  <Line2Icon
                    className={classNames(projectcss.all, sty.svg__zhNuR)}
                    role={"img"}
                  />

                  <div
                    data-plasmic-name={"viewDetails"}
                    data-plasmic-override={overrides.viewDetails}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails
                    )}
                  >
                    {"View Full Contract Details  >"}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"rectangle28"}
                data-plasmic-override={overrides.rectangle28}
                className={classNames(projectcss.all, sty.rectangle28)}
              >
                <div
                  data-plasmic-name={"figmaPaste2"}
                  data-plasmic-override={overrides.figmaPaste2}
                  className={classNames(projectcss.all, sty.figmaPaste2)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__okOVs
                    )}
                  >
                    {"Choose your payment method"}
                  </div>
                  <Line1Icon
                    className={classNames(projectcss.all, sty.svg__jfUs)}
                    role={"img"}
                  />

                  <BankTransferButton
                    data-plasmic-name={"handleBankTransfer"}
                    data-plasmic-override={overrides.handleBankTransfer}
                    className={classNames(
                      "__wab_instance",
                      sty.handleBankTransfer
                    )}
                  />

                  <CardPaymentButton
                    data-plasmic-name={"handleCardPayment"}
                    data-plasmic-override={overrides.handleCardPayment}
                    className={classNames(
                      "__wab_instance",
                      sty.handleCardPayment
                    )}
                  />
                </div>
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__niqGi
                )}
              >
                {"Powered by astrius"}
              </div>
            </div>
            <div
              data-plasmic-name={"sideBarInstance"}
              data-plasmic-override={overrides.sideBarInstance}
              className={classNames(projectcss.all, sty.sideBarInstance)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__fikDn)}>
                {renderPlasmicSlot({
                  defaultContents: "Social Media Marketing",
                  value: args.contractName,
                  className: classNames(sty.slotTargetContractName)
                })}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__dCsZx)}>
                {renderPlasmicSlot({
                  defaultContents: "$300.00",
                  value: args.amount,
                  className: classNames(sty.slotTargetAmount)
                })}
              </div>
              <div
                data-plasmic-name={"closeButton"}
                data-plasmic-override={overrides.closeButton}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.closeButton
                )}
              >
                {"X"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__kcncS
                )}
              >
                {"Qty 1"}
              </div>
              <div
                data-plasmic-name={"milestoneNameStack"}
                data-plasmic-override={overrides.milestoneNameStack}
                className={classNames(projectcss.all, sty.milestoneNameStack)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Milestone 2: Audit and Analysis",
                  value: args.milestoneName,
                  className: classNames(sty.slotTargetMilestoneName)
                })}
              </div>
              <Line1Icon
                className={classNames(projectcss.all, sty.svg__gTqv)}
                role={"img"}
              />

              <div
                data-plasmic-name={"viewContract"}
                data-plasmic-override={overrides.viewContract}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.viewContract
                )}
              >
                {"View Contract"}
              </div>
              <Line1Icon
                data-plasmic-name={"lowerBar"}
                data-plasmic-override={overrides.lowerBar}
                className={classNames(projectcss.all, sty.lowerBar)}
                role={"img"}
              />

              <div
                data-plasmic-name={"downloadContract"}
                data-plasmic-override={overrides.downloadContract}
                className={classNames(projectcss.all, sty.downloadContract)}
              >
                <Layer11Icon
                  className={classNames(projectcss.all, sty.svg__evk50)}
                  role={"img"}
                />

                <div className={classNames(projectcss.all, sty.freeBox__r53Q0)}>
                  <IconIcon
                    className={classNames(projectcss.all, sty.svg___6U3So)}
                    role={"img"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "goBackArrow",
    "goBackText",
    "sendButton",
    "sendText",
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "handleCardPayment",
    "sideBarInstance",
    "closeButton",
    "milestoneNameStack",
    "viewContract",
    "lowerBar",
    "downloadContract"
  ],

  goBackArrow: ["goBackArrow"],
  goBackText: ["goBackText"],
  sendButton: ["sendButton", "sendText"],
  sendText: ["sendText"],
  previewBody: [
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "handleCardPayment",
    "sideBarInstance",
    "closeButton",
    "milestoneNameStack",
    "viewContract",
    "lowerBar",
    "downloadContract"
  ],

  companyName: ["companyName"],
  rectangle29: ["rectangle29", "figmaPaste", "viewDetails"],
  figmaPaste: ["figmaPaste", "viewDetails"],
  viewDetails: ["viewDetails"],
  rectangle28: [
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "handleCardPayment"
  ],

  figmaPaste2: ["figmaPaste2", "handleBankTransfer", "handleCardPayment"],
  handleBankTransfer: ["handleBankTransfer"],
  handleCardPayment: ["handleCardPayment"],
  sideBarInstance: [
    "sideBarInstance",
    "closeButton",
    "milestoneNameStack",
    "viewContract",
    "lowerBar",
    "downloadContract"
  ],

  closeButton: ["closeButton"],
  milestoneNameStack: ["milestoneNameStack"],
  viewContract: ["viewContract"],
  lowerBar: ["lowerBar"],
  downloadContract: ["downloadContract"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEscrowPaymentsPagePreview__ArgProps,
          internalVariantPropNames:
            PlasmicEscrowPaymentsPagePreview__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEscrowPaymentsPagePreview__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicEscrowPaymentsPagePreview";
  } else {
    func.displayName = `PlasmicEscrowPaymentsPagePreview.${nodeName}`;
  }
  return func;
}

export const PlasmicEscrowPaymentsPagePreview = Object.assign(
  // Top-level PlasmicEscrowPaymentsPagePreview renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    goBackArrow: makeNodeComponent("goBackArrow"),
    goBackText: makeNodeComponent("goBackText"),
    sendButton: makeNodeComponent("sendButton"),
    sendText: makeNodeComponent("sendText"),
    previewBody: makeNodeComponent("previewBody"),
    companyName: makeNodeComponent("companyName"),
    rectangle29: makeNodeComponent("rectangle29"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    viewDetails: makeNodeComponent("viewDetails"),
    rectangle28: makeNodeComponent("rectangle28"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    handleBankTransfer: makeNodeComponent("handleBankTransfer"),
    handleCardPayment: makeNodeComponent("handleCardPayment"),
    sideBarInstance: makeNodeComponent("sideBarInstance"),
    closeButton: makeNodeComponent("closeButton"),
    milestoneNameStack: makeNodeComponent("milestoneNameStack"),
    viewContract: makeNodeComponent("viewContract"),
    lowerBar: makeNodeComponent("lowerBar"),
    downloadContract: makeNodeComponent("downloadContract"),
    // Metadata about props expected for PlasmicEscrowPaymentsPagePreview
    internalVariantProps: PlasmicEscrowPaymentsPagePreview__VariantProps,
    internalArgProps: PlasmicEscrowPaymentsPagePreview__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicEscrowPaymentsPagePreview;
/* prettier-ignore-end */
